<div class="modal-overlay" *ngIf="show" (click)="onClose()">
  <div class="modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ 'satisfaction.bulkReplyModal.header' | translate: { count: selectedFeedbacks.length, suffix: selectedFeedbacks.length > 1 ? 's' : '' } }}</h3>
      <button class="btn-close" (click)="onClose()">×</button>
    </div>
    <div class="modal-body">
      <div class="bulk-info">
        <p><strong>{{ 'satisfaction.bulkReplyModal.selectedSummary' | translate: { count: selectedFeedbacks.length, suffix: selectedFeedbacks.length > 1 ? 's' : '' } }}</strong></p>
        <p>{{ 'satisfaction.bulkReplyModal.sendNotice' | translate }}</p>
      </div>
      <div class="reply-form">
        <div class="template-select-wrapper">
          <label for="bulkTemplateSelect" class="template-label">
            <svg class="template-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            </svg>
            {{ 'satisfaction.common.templateLabel' | translate }}
          </label>
          <select
            id="bulkTemplateSelect"
            class="template-select"
            [(ngModel)]="selectedTemplate"
            (change)="onTemplateSelect()">
            <option value="">{{ 'satisfaction.common.chooseTemplateOption' | translate }}</option>
            <option *ngFor="let template of emailTemplates()" [value]="template.name">{{ template.name }}</option>
          </select>
        </div>

        <label for="bulkReplySubject">{{ 'satisfaction.common.subjectLabel' | translate }}</label>
        <input
          id="bulkReplySubject"
          type="text"
          [(ngModel)]="bulkReplySubject"
          [placeholder]="'satisfaction.common.subjectPlaceholder' | translate">

        <label for="bulkReplyMessage">{{ 'satisfaction.common.messageLabel' | translate }}</label>
        <textarea
          id="bulkReplyMessage"
          [(ngModel)]="bulkReplyMessage"
          rows="6"
          [placeholder]="'satisfaction.bulkReplyModal.messagePlaceholder' | translate"></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancel" (click)="onClose()">{{ 'common.actions.cancel' | translate }}</button>
      <button class="btn-send" (click)="onSendBulkReply()" [disabled]="!bulkReplyMessage.trim()">
        {{ 'satisfaction.bulkReplyModal.sendButton' | translate: { count: selectedFeedbacks.length } }}
      </button>
    </div>
  </div>
</div>